import { PCMilerMapClass } from "./PCMilerClass";
import { ORIGIN_MARKER_SVG, DESTINATION_MARKER_SVG, STOP_MARKER_SVG, NFR_MARKER_SVG } from '../../utils/constants'
import { GeoService } from "../../services/GeoService";

//should represent as a source interface to expose required methods.

class PCMilerMapWrapper extends PCMilerMapClass implements GeoService.MapSource {
    private readonly geocode: any = this.getGeocode();
    private readonly region: any = this._MapDefaultRegion;
    /**
     * render Load map
     */
    public renderMap(isLimitedZoom: boolean, container: GeoService.Container, bounds: GeoService.Bounds, style: string, fitBoundsOptions?: GeoService.FitBoundsOptions) {
        return this.createMapInstance(container, bounds, style, fitBoundsOptions).setMaxZoom(isLimitedZoom ? GeoService.MaxZoomLevel : undefined);
    }
    /**
     * createBounds
     */
    public createBounds(sw: GeoService.Sw, ne: GeoService.Ne) {
        return this.createLngLatBounds(sw, ne);
    }
    /**
     * render Load Route
     */
    public renderRoute(routeId: string, stops: GeoService.Stops, frameOptions: GeoService.FitBoundsOptions) {
        return this.createRouteInstance(routeId, stops, frameOptions)
    }
    /**
     * renders Marker
     */
    public renderMarker(svgContent: HTMLElement, lng: number, lat: number) {
        return this.createMarker(svgContent, lng, lat)
    }
    /**
     * returns Marker Popup
     */
    public renderPopup(options: GeoService.PopupOptions) {
        return this.createPopup(options);
    }
    /**
     * renders FullscreenControl
     */
    public renderFullscreenControl() {
        return this.createFullscreenControl();
    }
    /**
     * renders ExpandCollapseControl
     */
    public renderExpandCollapseControl(isDialog: boolean, onExpand: Function, onCollapse: Function) {
        return this.expandCollapseControl(isDialog, onExpand, onCollapse);
    }
    /**
     * getCoordinates
     */
    public getCoordinates({ city = "", state = "", postalCode = "", address = "" }: GeoService.Location): Promise<GeoService.GeoData[]> {
        const geocode = this.geocode
        const region = this.region
        return new Promise(function (resolve: any, reject: any) {
            geocode.geocode({
                address: {
                    addr: encodeURIComponent(address),
                    city,
                    state,
                    zip: postalCode,
                    region: region
                },
                listSize: 1,
                success: function (response: GeoService.GeoData) {
                    resolve(response);
                },
                failure: function (response: any) {
                    reject([]);
                }
            })
        })
    }
    public async getLongitudeLatitude(lng: number, lat: number) {
        return this.getLngLat(lng, lat);
    }
    public async searchCurrentAddress(query: any, getAddress: GeoService.GetAddressFunction) {
        return (await this.searchCurrentAddressPCmiler(query, getAddress));
    }

    public async searchAddress(query: any, getAddress: GeoService.GetAddressFunction) {
        return (await this.searchAddressPCmiler(query, getAddress));
    }

    /**
     * getNavigationControl will add Zoom In & Zoom Out control
     */
    public navControl(options: any) {
        return this.navigationControl(options)
    }
    /**
     * onDestroyInstance
     */
    public destroy() {
        this.onDestroy();
    }
    /**
     * stopMarker returns Marker SVG and its height
     */
    public getStopMarker(stopIndex: number, stopsLength: number, stopType: string) {
        const originMarker = { svg: ORIGIN_MARKER_SVG, height: 12 };
        const destinationMarker = { svg: DESTINATION_MARKER_SVG, height: 25 };
        const stopMarker = { svg: STOP_MARKER_SVG, height: 12 };
        const nFrMarker = { svg: NFR_MARKER_SVG, height: 12 };
        return (stopIndex === 0) ? originMarker : (stopIndex === stopsLength - 1) ? destinationMarker : stopType === "NFR" ? nFrMarker : stopMarker;
    }
}

export { PCMilerMapWrapper }

